export enum CurtainWorkablesTabEnums {
  FORM_MODE = 'FORM_MODE',
  LIST_MODE = 'LIST_MODE',
}
